import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {language} from '../../../language/vn';
import { FormBuilder} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import {CommandUtil} from '../../../global/commandutil';
import {BsModalService} from 'ngx-bootstrap/modal';
import {environment} from '../../../../environments/environment';

import {Staffs} from '../../../models/staff/staffs';
import {StaffsService} from '../../../service/staff/service-staffs';
import {GroupOTherComponent} from '../groupother/groupother.component';
import {ChucVu} from '../../../models/danhmuc/chucvu';
import {ChucVuService} from '../../../service/danhmuc/service-chucvu';
import {GroupInnerComponent} from '../groupother/groupinner.component';
import {StaffChucVu} from '../../../models/staff/staffchucvu';
import {StaffDepartment} from '../../../models/staff/staffdepartment';
import {tryCatch} from 'rxjs/internal-compatibility';
import {catchError} from 'rxjs/operators';

@Component({
  templateUrl: './ds.component.html',
  encapsulation: ViewEncapsulation.None
})
export class DSNguoiDungComponent implements OnInit, AfterViewInit {
  public language = language;
  public totalItems: number = 0;
  public hoSoId:  number;
  public currentPage: number   = environment.currentPage;
  public maxSize: number = environment.pageMaxRecord;
  public numPages: number = environment.numberPages;
  public defaultValue: string[]=["-1"];
  public dataList: Staffs[];
  public srKeyword: string = '';
  public srDonViId: String = '-1';
  public srChucVu: number= -1;
  public dataChucVu: ChucVu[] = [];
  @ViewChild("selectGroup")
  public selectGroup: GroupInnerComponent;
  constructor( public staffsService: StaffsService,
               public formBuilder: FormBuilder,
               public toastr: ToastrService,
               public bsModalService: BsModalService,
               public chucVuService: ChucVuService,
               public commandUtil: CommandUtil

  ) {
  }
  ngAfterViewInit() {

  }
  getAvatar(file: string)
  {
    if(file !== null && file !== '')
       return this.commandUtil.getUrlAvatar(file);
    return "assets/img/avatars/1.jpg";
  }
  genArrayChucVu(staffChucVu: StaffChucVu[] )
  {
    if (staffChucVu !== null)
          return staffChucVu.map(x => x.chucVuItem.tenChucVu).join(', ');
    return '';
  }
  genArrayDonVi(staffDonVi: StaffDepartment [] )
  {
    try {
      if (staffDonVi !== null && staffDonVi.filter(x => x.donViItem !== null ).length>0)
        return staffDonVi.map(x => x.donViItem.tenCQ).join(', ');
    }catch{

    }
    return '';
  }
  ngOnInit(): void {

    this.chucVuService.getAll().subscribe(data=> this.dataChucVu = data);
    this.search();
  }
  search()
  {
    this.srDonViId= this.selectGroup!=null? this.selectGroup.selectTree.value.toString(): '-1';
    this.staffsService.findAllByPaging(this.srKeyword, this.srChucVu, (this.srDonViId!=''? this.srDonViId: '-1'), 1 , this.currentPage, this.maxSize).subscribe(dataList => this.dataList = dataList);
    this.staffsService.getCountByKeyword(this.srKeyword, this.srChucVu, (this.srDonViId!=''? this.srDonViId: '-1'), 1).subscribe(recordCount => this.totalItems = recordCount);
  }
  pageChanged(event: any): void {
    this.currentPage = event.page;
    this.search();

  }

}

